export const initEnrolmentFormData = (): IEnrolmentFormData => ({
  contactEmail: '',
  contactPhoneNumber: '',
  medicalRequirements: '',
  parentFirstName: '',
  parentLastName: '',
  studentDateOfBirth: '',
  studentFirstName: '',
  studentLastName: ''
});

export interface IEnrolmentFormData {
  parentFirstName: string;
  parentLastName: string;
  contactPhoneNumber: string;
  contactEmail: string;
  studentFirstName: string;
  studentLastName: string;
  studentDateOfBirth: string;
  medicalRequirements: string;
  enrolmentStartDate?: string;
}

export interface IBasicAuthDanceSchoolEnrolStudentRequestSelectedDanceClass {
  danceClassId: string;
  trialDate?: string;
}

export interface IBasicAuthDanceSchoolEnrolStudentRequest extends IEnrolmentFormData {
  selectedDanceClasses: IBasicAuthDanceSchoolEnrolStudentRequestSelectedDanceClass[];
  enrolAsTrial: boolean;
  preCalculatedDiscountedTermCost: number;
}